
const BooleansView = ({booleans}) =>{
    if(!booleans || !Object.keys(booleans) || !Object.keys(booleans).length) return null

 
    return (<>
       { Object.keys(booleans).map(key=>{
            return <>
                   <span className={`grid-results-header ${booleans[key]?'status--completed':'status--open'} `}> {booleans[key].toString()}</span>
                   <span className='grid-results-data'>
                   {key}
                    </span>
                   </>
        })
       }
    </>)
}
export default BooleansView